<template>
  <f7-page name="login" class="login BG">
    <div class="app-logo">&nbsp;</div>
    <!-- User Name -->
    <f7-row>
      <f7-col width="30"></f7-col>
      <f7-col width="40">
        <f7-row>
          <f7-col width="100">
            <div class="app-logo">
              <div class="app-logo-dev left-app-logo yellow">AZ</div>
              <div class="app-logo-dev right-app-logo white">
                <span>| CONNECT</span>
              </div>
            </div>
          </f7-col>
        </f7-row>
        <f7-list no-hairlines-md cl class="login-input">
          <f7-list-input
          v-on:keyup.enter="login"
            outline
            type="text"
            placeholder="Identity (username or phone)"
            :value="user.identity"
            @input="user.identity = $event.target.value"
          ></f7-list-input>
        <!-- Password -->
        <f7-list-input
          v-on:keyup.enter="login"
          outline
            type="password"
            placeholder="Password"
            :value="user.password"
            @input="user.password = $event.target.value"
          ></f7-list-input>
        </f7-list>

        <f7-row>
          <f7-col width="100">
            <div class="action-login">
                <f7-row>
                  <f7-col width="80">
                    <div class="action-login-text">
                      Don’t have an account ? <a href="/registration/" class="yellow"> Sign up !</a>
                    </div>
                    <div class="action-login-text" style="height: auto">
                      <a href="/forgot-password/" class="yellow" style="margin: 0">Forgot Password </a>
                    </div>

                  </f7-col>
                  <f7-col width="20">
                    <div class="login-button">
                      <a href="#" @click="login">
                          <img src="../assets/images/next.png" />
                        </a>
                    </div>
                  </f7-col>
                </f7-row>
            </div>
          </f7-col>
      <f7-col width="100">
        <f7-col width="100">
            <div class="sponser sponser-login">
              <p>Sponsored by</p>
              <div class="sponser-logo">
                <img src="../assets/svg/astra_zeneca_logo-w.svg" />
              </div>
            </div>
          </f7-col>
      </f7-col>
        </f7-row>

      </f7-col>
      <f7-col width="30"></f7-col>
    </f7-row>
  </f7-page>
</template>

<script>
export default {
  data() {
    return {
      user: {
        identity: '',
        password: ''
      }
    }
  },
  methods: {
    login: function () {
      this.$f7.preloader.hide()
      var _vm = this
      if (!_vm.user.identity || !_vm.user.password) {
        _vm.$f7.dialog.alert('Please enter your identity and password')
        return false;
      }

      this.$http.post(this.$root.apiBaseURL + 'login', this.user)
        .then( function(res) {
          _vm.$f7.preloader.hide()
          if(res.data.user.status != 1) {
            _vm.$f7.dialog.alert('Sorry, but your account still wating the admin approval', 'Error!')
            return false
          } else {
            _vm.$root.user = res.data.user
            _vm.$root.authrizeUser(_vm.$root.user, res.data.token)
            _vm.$root.updateUserToken()
            _vm.$f7.view.current.router.navigate('/', { clearPreviousHistory: true })
          }
        })
        .catch( function(error) {
          _vm.$f7.dialog.alert(error.response.data.error, 'Error!')
          _vm.$f7.preloader.hide()
          console.log(error)
        })
    }
  },
  mounted() {
    if (localStorage.getItem('isLoggedIn')) {
      this.$f7.view.current.router.navigate('/', { clearPreviousHistory: true })
    }
  }
}
</script>
